<dx-date-box #datepicker
             [type]="type"
             [min]="minDate"
             [max]="maxDate"
             [interval]="timeInterval"
             [readOnly]="readonly"
             showClearButton="true"
             [displayFormat]="format"
             (onValueChanged)="dateChanged($event)"
             width="100%">
    <dx-validator #validator>
        <dxi-validation-rule type="custom"
                             [validationCallback]="validationCallback"
                             message="The selected time is not valid"></dxi-validation-rule>
        @if(required){
            <dxi-validation-rule type="required" message="Required"></dxi-validation-rule>
        }
    </dx-validator>
</dx-date-box>